import assign from '@ali/xutil/assign';
import QianniuAppDetect from '../common/qianniu-pc-app-detect';

let _settings = {
  /**
   * 是否使用 Ajax 发送网关请求，在千牛内默认不使用
   * @type {Boolean}
   */
  useAjax: !(QianniuAppDetect.isQianniu || window.workbench),
  /**
   * 设置客户端代理请求的网关接口返回结果和使用Ajax请求的返回结果一致
   * 1. 数据外壳去除 `xxx_xxx_response` 的包裹，如：`multi_resource_numbers_my_get_post_response`
   * 2. 数据结果对象的 key 为 camelcase 形式
   */
  response_style: 'h5_style',
};

export default {

  /**
   * 配置网关
   * @param  {Object} options
   * @param  {Boolean} options.useAjax optional 是否使用 Ajax 发起网关请求
   * @param  {String} options.response_style optional 返回结果形式
   */
  setup(options) {
    assign.deep(_settings, options);
  },

  /**
   * 获取配置，如果传入 key，则返回对应 key 的配置信息；如果未传，则返回全量配置的拷贝。
   * @param  {String} key optional 配置 key
   * @return {Any}    单个或全部配置信息
   */
  get(key) {
    return key ? _settings[key] : assign.deep({}, _settings);
  }
}



// WEBPACK FOOTER //
// ./src/common/qianniu-gateway-settings.js